import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { memo, useMemo } from "react";
import Image from "next/image";
import { useI18n } from "@/i18n/I18nProvider";

function BranchServicesSection({ branchLabel }) {
  const { t, locale } = useI18n();

  // avoid recalculations on every render
  const bodyText = useMemo(() => {
    return t.branches.services.body.replace("{{branch}}", branchLabel);
  }, [t, branchLabel]);


  return (
    <Box
      component="section"
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: { xs: 5, lg: 10 },
        backgroundColor: { xs: "transparent", md: "#FFF" },
        color: "#282781",
        mt: { xs: 6, md: 10 },
        overflow: "visible",
      }}
      className="horizontal-safe-padding vertical-safe-padding"
    >
      {/* Wrap the image to keep your transforms */}
      <Box
        sx={{
          maxWidth: { xs: 315, md: 400, lg: 520 },
          width: "100%",
          transform: {
            md: "translateY(-160px)",
            lg: "translateY(-200px)",
          },
          // optional: smoother paint on some device
        }}
      >
        <Image
          src={`https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/office-${locale}.png`}
          alt={t.branches.services.branchAlt}
          // IMPORTANT: reserve space => prevents CLS
          // لو ما تعرفش المقاس الحقيقي للصورة: خليهم تقريبًا بنفس الـ aspect ratio
          width={1040}
          height={830}
          // below the fold => don't use priority
          loading="lazy"
          decoding="async"
          sizes="(max-width: 600px) 315px, (max-width: 900px) 400px, 520px"
          style={{
            width: "100%",
            height: "auto",
            display: "block",
          }}
        />
      </Box>

      <Box>
        <Typography
          component="h2"
          fontWeight={700}
          sx={{
            fontSize: { xs: 28, sm: 36, md: 44, lg: 50 },
            color: "#FFF",
            transform: {
              xs: "translateY(-10px)",
              md: "translateY(-130px)",
            },
          }}
        >
          {t.branches.services.title}
        </Typography>

        <Typography
          fontWeight={500}
          sx={{
            fontSize: { md: 15 },
            lineHeight: { xs: 1.9, md: 1.8 },
            color: "#000",
            display: { xs: "none", md: "block" },
            p: { xs: 2, md: 0 },
            mt: { xs: 1, md: 0 },
            transform: { xs: "none", md: "translateY(-100px)" },
            maxWidth: 700,
          }}
        >
          {bodyText}
        </Typography>
      </Box>
    </Box>
  );
}

export default memo(BranchServicesSection);
